import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from 'app/app.component';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withNavigationErrorHandler,
} from '@angular/router';
import {appRoutes} from 'app/app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {ErrorHandler, importProvidersFrom, isDevMode, provideZoneChangeDetection} from '@angular/core';
import {seFeIconCopy, SeFeIconModule, seFeIconReceiptThin, seFeIconSpotClipboard} from 'se-fe-icon';
import {environment} from './environments/environment';
import {SeFeApiModule} from 'se-fe-api';
import {SeFeDomainEnvironmentModule} from 'se-fe-domain-environment';
import {SeFeAuthSupportModule} from 'se-fe-auth-support';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {provideRouterStore} from '@ngrx/router-store';
import {provideStore} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {RouterEffects} from 'app/core/state/router.effects';
import {APP_REDUCERS} from 'app/core/state';
import {ErrorEffects} from 'app/core/components/error-page/state/error.effects';
import {GlobalErrorHandler} from 'app/core/handlers/global-error-handler.service';
import {errorInterceptor} from 'app/core/interceptors/error-interceptor.service';
import {navigationErrorHandler} from 'app/core/handlers/navigation-error-handler';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      withNavigationErrorHandler(navigationErrorHandler)
    ),
    provideHttpClient(withInterceptors([errorInterceptor])),
    provideAnimations(),
    provideZoneChangeDetection({eventCoalescing: true}),
    importProvidersFrom(
      SeFeIconModule.include([seFeIconReceiptThin, seFeIconCopy, seFeIconSpotClipboard]),
      SeFeApiModule.forRoot({domainEnvironments: environment.domainSpecificUrls}),
      SeFeDomainEnvironmentModule.forRoot({domainEnvironments: environment.domainSpecificUrls}),
      SeFeAuthSupportModule.forRoot(environment)
    ),
    provideStore(APP_REDUCERS),
    provideRouterStore(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
    }),
    provideEffects(RouterEffects, ErrorEffects),
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
  ],
  // eslint-disable-next-line no-console
}).catch(err => console.error(err));
